<div class="ac-logs-page">
  <header class="ac-logs-header">
    <div>
      <h1>Access Control Logs</h1>
      <p>QR / RFID hardware validation calls</p>
    </div>
    <div class="ac-logs-controls">
      <select [(ngModel)]="endpointFilter" (change)="loadLogs()">
        <option value="">All endpoints</option>
        <option value="validate-qr">validate-qr</option>
        <option value="validate-rfid">validate-rfid</option>
      </select>
      <select [(ngModel)]="limit" (change)="loadLogs()">
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
        <option [ngValue]="200">200</option>
        <option [ngValue]="500">500</option>
      </select>
      <button type="button" (click)="loadLogs()" [disabled]="loading">
        {{ loading ? 'Loading…' : 'Refresh' }}
      </button>
    </div>
  </header>

  <div *ngIf="error" class="ac-logs-error">{{ error }}</div>

  <div class="ac-logs-meta" *ngIf="!error">
    Showing {{ logs.length }} latest record(s)
  </div>

  <div class="ac-logs-table-wrap">
    <table class="ac-logs-table">
      <thead>
        <tr>
          <th>#</th>
          <th>When</th>
          <th>Endpoint</th>
          <th>HTTP</th>
          <th>Result</th>
          <th>IP</th>
          <th>Device key</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of logs; let i = index">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ row.createdAt | date: 'medium' }}</td>
            <td><code>{{ row.endpoint }}</code></td>
            <td>{{ row.httpStatus }}</td>
            <td>
              <span class="badge" [ngClass]="statusClass(row.httpStatus, row.responseBody)">
                {{ responseStatus(row.responseBody) }}
              </span>
            </td>
            <td>{{ row.clientIp || '—' }}</td>
            <td class="mono truncate" [title]="row.deviceAccessKey">
              {{ row.deviceAccessKey || '—' }}
            </td>
            <td>
              <button type="button" class="linkish" (click)="toggleExpand(row._id)">
                {{ expandedId === row._id ? 'Hide' : 'Details' }}
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedId === row._id" class="detail-row">
            <td colspan="8">
              <div class="detail-grid">
                <div>
                  <h3>Request body</h3>
                  <pre>{{ formatJson(row.requestBody) }}</pre>
                </div>
                <div>
                  <h3>Response body</h3>
                  <pre>{{ formatJson(row.responseBody) }}</pre>
                </div>
                <div class="full">
                  <h3>User agent</h3>
                  <pre>{{ row.userAgent || '—' }}</pre>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!loading && !error && logs.length === 0">
          <td colspan="8" class="empty">No access control logs yet.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
